import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';

import { Button } from '@eventbrite/eds-button';

import ModalMessage from '../ModalMessage';

import { COMMON_DOMAIN_EMAILS } from '../../constants';

import './PasswordlessEmailStatus.scss';

const PasswordlessEmailStatus = ({ email, onClick }) => {
    const componentClasses = classNames(
        'eds-l-mar-vert-14 passwordless-email-status',
    );

    const headerText = gettext('Check your email to log in');
    let subtitleText = gettext(
        'We sent your login link to your email address.',
    );

    //Need to conditionally check if the email is present and update copy accordingly
    //in case the user refreshes the notification page and we lose the email from state.
    if (email) {
        subtitleText = (
            <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: gettext(
                        'We sent your login link to <strong>%(email)s</strong>.',
                        {
                            email,
                        },
                    ).toString(),
                }}
            />
        );
    }
    let buttonText = gettext('OK');
    let buttonEvent = onClick;
    let backDiv = '';
    if (email) {
        //extract domain and determine redirection
        const [emailUser, emailDomain] = email.split('@');
        if (
            emailDomain &&
            Object.prototype.hasOwnProperty.call(
                COMMON_DOMAIN_EMAILS,
                emailDomain,
            )
        ) {
            buttonText = gettext('Take me to my email');
            buttonEvent = () => {
                window.open(COMMON_DOMAIN_EMAILS[emailDomain], '_blank');
            };
            backDiv = (
                <div className="eds-text-color--ui-800 eds-text-weight--heavy  eds-align--center eds-l-mar-top-5">
                    <Button
                        onClick={onClick}
                        type="button"
                        style="anchor"
                        data-testid="passwordless-back-login"
                    >
                        {gettext('Go to Log In')}
                    </Button>
                </div>
            );
        }
    }

    return (
        <div className={componentClasses}>
            <ModalMessage headerText={headerText} subtitleText={subtitleText} />

            <div className="eds-l-pad-top-8 eds-align--center">
                <Button
                    style="link"
                    onClick={buttonEvent}
                    data-testid="passwordless-ok-button"
                    __containerClassName="passwordless-form__button--grey"
                >
                    {buttonText}
                </Button>
            </div>
            {backDiv}
        </div>
    );
};

PasswordlessEmailStatus.propTypes = {
    email: PropTypes.string,
};

export default PasswordlessEmailStatus;
